import React, { Component } from 'react';
import { HashRouter as Router, Route } from 'react-router-dom'

import Header from "../Header/Header"
import Footer from "../Footer/Footer"
import Homepage from "./Homepage"
import Article from "./Article"


class App extends Component {
  constructor() {
    super();
    this.scrollFromMenu = this.scrollFromMenu.bind(this);
    this.state = {
      goToSection: "section-promo"
    }
  }
  scrollFromMenu(comp) {
    this.setState({
      goToSection: comp
    });
  }
  render() {
    return (
      <div className="Isracard-Wrapper">
        <Router basename="/">
          <div>
            <Header scrollFromMenu={this.scrollFromMenu} />
            <Route exact path="/" component={() => <Homepage goToSection={this.state.goToSection} />} />
            <Route path="/article/:id" component={Article} />
            <Footer />
          </div>
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js